<template>
  <div class="site-page nav-content-inset">
    <div class="site-page__inner">
      <h1 class="site-page__title">提现申请</h1>
      <p class="hint">余额提现至银行卡，审核通过后由财务批量打款。</p>

      <el-card shadow="never" class="apply-card">
        <el-form label-width="100px">
          <el-form-item label="提现金额（元）" required>
            <el-input-number v-model="amountYuan" :min="1" :max="100000" :precision="2" />
          </el-form-item>
          <el-form-item label="开户银行" required>
            <el-input v-model="form.bankName" />
          </el-form-item>
          <el-form-item label="银行卡号" required>
            <el-input v-model="form.bankAccount" />
          </el-form-item>
          <el-form-item label="户名" required>
            <el-input v-model="form.accountName" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :loading="submitting" @click="submit">提交申请</el-button>
          </el-form-item>
        </el-form>
      </el-card>

      <h3>申请记录</h3>
      <el-table :data="items" v-loading="loading" border>
        <el-table-column label="金额（元）" width="110">
          <template #default="s">{{ (s.row.amountCents / 100).toFixed(2) }}</template>
        </el-table-column>
        <el-table-column prop="bankName" label="银行" width="120" />
        <el-table-column prop="status" label="状态" width="130">
          <template #default="s">{{ withdrawLabel(s.row.status) }}</template>
        </el-table-column>
        <el-table-column prop="adminReply" label="备注" min-width="140" />
        <el-table-column label="时间" width="170">
          <template #default="s">{{ formatTime(s.row.createdAt) }}</template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import {
  fetchWithdrawApplyList,
  submitWithdrawApply,
  WITHDRAW_STATUS_LABELS
} from '@/utils/userHub'

export default {
  name: 'WithdrawApplyView',
  data() {
    return {
      amountYuan: 10,
      form: { bankName: '', bankAccount: '', accountName: '' },
      submitting: false,
      loading: false,
      items: []
    }
  },
  created() {
    this.loadList()
  },
  methods: {
    withdrawLabel(s) {
      return WITHDRAW_STATUS_LABELS[s] || s
    },
    formatTime(ts) {
      if (!ts) return '—'
      return new Date(Number(ts) * 1000).toLocaleString()
    },
    async loadList() {
      this.loading = true
      try {
        const data = await fetchWithdrawApplyList()
        this.items = data.items || []
      } catch (e) {
        this.$message.error(e.message || '加载失败')
      } finally {
        this.loading = false
      }
    },
    async submit() {
      this.submitting = true
      try {
        await submitWithdrawApply({
          amountCents: Math.round(this.amountYuan * 100),
          ...this.form
        })
        this.$message.success('提现申请已提交')
        this.loadList()
      } catch (e) {
        this.$message.error(e.message || '提交失败')
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style scoped>
.hint { color: #666; margin-bottom: 16px; }
.apply-card { margin-bottom: 24px; }
</style>
